"use strict";
(function ($) {
    "use strict";
    if (document.querySelectorAll('.js-minimal-number-steps .gf_page_steps').length > 0) {
        function topSteps() {
            // Count number of steps, apply to .gf_steps_label::before using attr()
            var fwcSteps = document.querySelectorAll('.gf_step_number');
            var fwcStepsLength = fwcSteps.length;
            var fwcLabel = document.querySelectorAll('.gf_step_label');
            for (var i = 0; i < fwcStepsLength; i++) {
                fwcLabel[i].setAttribute('data-before', fwcStepsLength);
            }
        }
        topSteps();
        jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
            topSteps();
        });
    }
})(jQuery);
